module.exports = __webpack_public_path__ + "static/media/avatar.3caa4d83.png";